<template>
    <div>
     <Mainlayout></Mainlayout>
    <div class="c-app flex-row align-items-center">
  <CContainer style="display: flex; justify-content: center" class="p-0">
    <div class="container-box center">
      <div class="text-left">
        <div class="card-custom-web p-2" style="height:100vh">
      
          <div v-if="LeaderBoard.length != ''">
        <CRow class="text-center">
        <div style="width: 33%">
          <div
            class="text-center"
            v-for="(item, index) in LeaderBoard.slice(0, 2)"
            v-bind:key="item.id"
          >
            <div v-if="index === 1">
              <h4 class="text-center mt-5 text-black">2</h4>
              <img src="../assets/img/icon/second.svg" />
              <br />
            
              <img
                style="border-radius: 50%;max-width:100px"
                class="p-0 circle-bg-top3 mt-2"
                src="../assets/img/icon/user.png"
              />
              <br />
              <h3 class="custom-16px mt-3 text-center">
                {{ item.Name }}
              </h3>
              <h3 class="custom-mark-merdeka">{{ item.Percentage }} %</h3>
            </div>
          </div>
        </div>
        <div style="width: 33%">
          <div
            class="text-center"
            v-for="(item, index) in LeaderBoard.slice(0, 1)"
            v-bind:key="item.quizScoreId"
          >
            <div v-if="index === 0">
              <h4 class="text-center text-black">1</h4>
              <img src="../assets/img/icon/first.svg" />
              <br />
             
              <img
                style="border-radius: 50%;max-width:100px"
                class="p-0 circle-bg-top3 mt-2"
                src="../assets/img/icon/user.png"
              />
              <br />
              <h3 class="custom-16px mt-3 text-center">
                {{ item.Name }}
              </h3>
              <h3 class="custom-mark-merdeka">{{ item.Percentage }} %</h3>
            </div>
          </div>
        </div>
        <div style="width: 33%">
          <div
            class="text-center"
            v-for="(item, index) in LeaderBoard.slice(0, 3)"
            v-bind:key="item.quizScoreId"
          >
            <div v-if="index === 2">
              <h4 class="text-center mt-5 text-black">3</h4>
              <img src="../assets/img/icon/third.svg" />
              <br />
            
              <img
                style="border-radius: 50%;max-width:100px"
                class="p-0 circle-bg-top3 mt-2"
                src="../assets/img/icon/user.png"
              />
              <br />
              <h3 class="custom-16px mt-3 text-center">
                {{ item.Name }}
              </h3>
              <h3 class="custom-mark-merdeka">{{ item.Percentage }} %</h3>
            </div>
            <div v-else></div>
          </div>
        </div>
      </CRow>

      <div class="text-center">
        <div v-for="(item, index) in LeaderBoard" v-bind:key="item.ID" v-if="index >= 3">
          <div style="width: 100%; display: block" class="pl-2 pr-2">
            <CCard style="width: 100%">
              <CRow class="p-2">
                <div style="width: 10%">
                  <h3 class="custom-index-merdeka">{{ index + 1 }}</h3>
                </div>
                <div style="width: 60%">
                  <h3 class="custom-16px text-uppercase text-left">
                    {{ item.Name }}
                  </h3>
                </div>
                <div style="width: 30%">
                  <h3 class="custom-mark-merdeka text-right mr-3">{{ item.Percentage }} % </h3>
                </div>
              </CRow>
            </CCard>
          </div>
        </div>
      </div>
      </div>
      <div v-else>
        <br /><br />
<div class="text-center">
        <img src="../assets/img/icon/nodata.png" class="text-center" style="max-width:50%"/>
        <h4 class="text-black">No student taken this exam yet.Please share <br />
            to many friends as possible  and help them to succeed</h4>
        <br />
      </div>
      </div>
          </div>
          </div>
          </div>
          </CContainer>
          <!-- <div class="header-top">{{ quiz.title }}</div>
  <div class="header-left">
    <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
  </div>
  <div class="header-right">
    <span @click="GoHomePage()"><CIcon name="cil-home"/></span>
    <br />
    
  </div> -->
  <div style="clear: both"></div>
          </div>
        </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import moment from "moment";
import Mainlayout from "../containers/TheHeaderLeaderboard.vue";

import _ from "lodash";

export default {
name: "Login",
data() {
  return {
    LeaderBoard: [],
    LeaderBoardData: true,
    NoData: false,
    quiz: {},
  };
},
components: {
    Mainlayout,
  },
async mounted() {
  await this.GetConfirmationClass();
  this.GetQuizDetail();
},
methods: {
  GetQuizDetail() {
    this.$API
    .get(this.$GetGuiLeaderBoard + "?gui=" + this.$route.query.guidId)
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.quiz = response.data;
        }
      });
  },
  async GetConfirmationClass() {
    this.$API
      .get(this.$GetGuiLeaderBoard + "?gui=" + this.$route.query.guidId)
      .then((response) => {
        if (response.status == 200 && response.data != null) {
          this.LeaderBoard = response.data;
        }
        else if(response.status === 500)
        {
          this.LeaderBoardData = false;
          this.NoData = true;
        }
        else
        {

        }
      })
      .catch((error) => {
      if (error.response) {
        this.LeaderBoardData = false;
          this.NoData = true;
      }
    });
  },
 
  GoHomePage() {
    this.$router.push("../ExistingUser")
  },
},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
font-family: "Montserrat", sans-serif;
}

</style>